import React from "react";

export default function HyperImageLink(props) {
  return (
    <a href={props.url} className="text-white pr-0" target={ props.redirect ? "": "_new"}>
        <img src={props.source} alt={props.alt} {...props.imageProps} />
    </a>
  );
}
